'use client';

// import { CursorController } from './cursor.controller'
import { Initialize } from './initialize';
import { KeyboardController } from './keyboard.controller';
import { ThemeController } from './theme.controller';
export const Controllers = () => {
  return <>
      <Initialize />
      <ThemeController />
      {/* <CursorController /> */}
      <KeyboardController />
    </>;
};